import React, { useEffect } from 'react';
import { MainRoute } from './infrastructure';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {

    const url = window.location.href;
    const hostname = window.location.hostname;
    const [, stage, , flag] = url.split('.');

    if (hostname !== 'localhost' && stage !== 'dev') {
        console.log = function () {};
    }

    return <MainRoute />;
}

export default App;
